/*
*   List of Actions with TYPE that should be passed from administration.reducer.js to adm-accounts-clients.reducer.js
 */
export const PREFIX = 'ADM_ACCOUNTS_CLIENTS';

export const TYPES = {
    FETCH_CLIENT_ACCOUNT_DETAILS:   `${PREFIX}_FETCH_CLIENT_ACCOUNT_DETAILS`,
    RESET_GRID_FILTER:      `${PREFIX}_RESET_GRID_FILTER`,
    FETCH_ROLE_OPTIONS:     `${PREFIX}_FETCH_ROLE_OPTIONS`,
    RESET_CLIENT_DETAILS:   `${PREFIX}_RESET_CLIENT_DETAILS`,
    FETCH_SITE_CAPABILITIES_OPTIONS:`${PREFIX}_FETCH_SITE_CAPABILITIES_OPTIONS`,
    FETCH_OUTSOURCED_MANAGEMENT_PROVIDER_OPTIONS: `${PREFIX}_FETCH_OUTSOURCED_MANAGEMENT_PROVIDER_OPTIONS`,
};
